<template lang="pug" src="./templates/BillingAddressModal.pug"></template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required, requiredIf, numeric, minLength, maxLength,
} from 'vuelidate/lib/validators';
import PostalCodeInput from '../form/PostalCodeInput.vue';
import { RepositoryFactory } from '../../repositoryFactory';
import notify from '../notify';

const BillingAddressRepository = RepositoryFactory.get('billingAddress');
const AreaRepository = RepositoryFactory.get('area');

export default {
  components: {
    PostalCodeInput,
  },
  mixins: [validationMixin],
  props: {
    mode: {
      type: String,
      default: 'create',
    },
    name: {
      type: String,
      required: true,
      default: 'billing-modal',
    },
  },
  data() {
    const data = {
      address: {
        company_name: '',
        tax_number: '',
        branch_number: '',
        is_headquarter: 1,
        address: '',
        postal_code: '',
        province_id: '',
        amphure_id: '',
        district_txt: '',
      },
      options: {
        provinces: [],
        amphures: [],
        districts: [],
      },
    };
    return data;
  },
  mounted() {
    this.getProvinces();

    this.$watch('address.is_headquarter', (val, oldVal) => {
      if (val === oldVal) return;
      if (val === 1) {
        this.address = { ...this.address, ...{ branch_number: '' } };
      }
    });

    this.$watch('address.province_id', (val, oldVal) => {
      if ((val !== oldVal)) {
        if (oldVal !== '') {
          this.address = { ...this.address, ...{ amphure_id: '', district: '' } };
          this.options = { ...this.options, ...{ amphures: [], districts: [] } };
        }
        this.getAmphures({ province_id: val });
      }
    });

    this.$watch('address.amphure_id', (val, oldVal) => {
      if ((val !== oldVal)) {
        if (oldVal !== '') {
          this.address = { ...this.address, ...{ district: '' } };
          this.options = { ...this.options, ...{ districts: [] } };
        }
      }
    });
  },
  methods: {
    async getProvinces() {
      const { data } = await AreaRepository.getProvinces();
      this.options.provinces = data;
    },
    async getAmphures(query) {
      const { data } = await AreaRepository.getAmphures(query);
      this.options.amphures = data;
    },
    async getDistricts(query) {
      const { data } = await AreaRepository.getDistricts(query);
      this.options.districts = data;
    },
    onPostalCodeUpdate(val) {
      this.$v.address.postal_code.$model = val;
    },
    onPostalCodeSelected(item) {
      this.$v.address.postal_code.$model = item.zip_code;
      this.$v.address.province.$model = item.amphure.province;
      delete item.amphure.province;
      this.$v.address.amphure.$model = item.amphure;
      delete item.amphure;
      this.$v.address.district.$model = item;
    },
    async getAddress(id) {
      try {
        const { data } = await BillingAddressRepository.show(id).then((resp) => resp.data);
        this.address = { ...this.address, ...data };
      } catch (e) {
        this.$bvModal.hide(`edit-billing-modal-${this.address.id}`);
        notify.errors(this, e);
      }
    },
    onOpened() {
      if (this.mode === 'edit') {
        this.getAddress(this.$attrs.addressId);
      }
    },
    async onSave() {
      this.$wait.start('creating billing address');
      try {
        const { data } = await BillingAddressRepository.store(this.address);
        this.$emit('created', data);
        notify.success(this, { title: Lang.get('alerts.general.operation_completed'), text: false });
        this.$bvModal.hide('create-billing-modal');
      } catch (e) {
        notify.errors(this, e);
      }
      this.$wait.end('creating billing address');
    },
    async onUpdate() {
      this.$wait.start('updating billing address');
      try {
        const { data } = await BillingAddressRepository.update(this.address);
        this.$emit('updated', data);
        notify.success(this, { title: Lang.get('alerts.general.operation_completed'), text: false });
        this.$bvModal.hide(`edit-billing-modal-${this.address.id}`);
      } catch (e) {
        notify.errors(this, e);
      }
      this.$wait.end('updating billing address');
    },
    onHidden() {
      this.$v.$reset();
      this.address = {
        company_name: '',
        tax_number: '',
        branch_number: '',
        is_headquarter: 1,
        address: '',
        postal_code: '',
        province_id: '',
        amphure_id: '',
        district: '',
      };
    },
    isNumber(evt) {
      evt = (evt) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
      return false;
    },
  },
  validations: {
    address: {
      company_name: {
        required,
      },
      tax_number: {
        required,
        numeric,
        minLength: minLength(13),
        maxLength: maxLength(13),
      },
      branch_number: {
        required: requiredIf(function () {
          return this.address.is_headquarter === 0;
        }),
        numeric,
      },
      is_headquarter: {
        required,
        numeric,
      },
      address: {
        required,
      },
      province_id: {
        required,
      },
      amphure_id: {
        required,
      },
      district_txt: {
        required,
      },
      postal_code: {
        required,
      },
    },
  },
};
</script>
